export default function hasCookie(name) {
  const re = new RegExp(name + '=([^;]+)')
  const value = re.exec(document.cookie)
  return value !== null
}
